import BaseHttp from '@/plugins/baseHttp';

const patch = (payload,) => {
  if(payload.financial_status === 'DEFAULTER') {
    return BaseHttp.post('/stores/suspend/batch', payload,);
  }
  return BaseHttp.patch('/stores/financial-status', payload,);
};

const bulkUpdate = (payload,) => {
  return BaseHttp.post('/stores/bulk-financial-status-update', payload,);
};

const handleError = (error,) => {
  return BaseHttp.handleError(error,);
};

export default {
  patch,
  bulkUpdate,
  handleError,
};
